import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["disabled", "required", "multiple", "autocomplete", "id"];
const _hoisted_2 = ["value", "disabled"];
import { computed } from "vue";
import { cloneDeep } from "lodash";
import trans from "../../services/Translator";
import { autocompleteAttr } from "./FormUtils";
import { choiceLabel } from "./fieldValues";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlChoiceSelection',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlChoiceSelection');
        const choices = computed(() => {
            const choices = [];
            if (!fieldOptions.value.required) {
                choices.push({ value: '', label: trans('fieldOptions.no_value') });
            }
            (fieldOptions.value.choices || [])
                .forEach(choice => choices.push({ ...choice, label: choiceLabel(props.form, props.field, choice) }));
            return choices;
        });
        const autocomplete = computed(() => autocompleteAttr(fieldOptions.value));
        const model = useFieldModel(() => {
            if (!props.data && fieldOptions.value.multiple) {
                return [];
            }
            return cloneDeep(props.data) ?? null;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                    onChange: _cache[1] || (_cache[1] = ($event) => (_unref(emitChange)(_unref(model)))),
                    onFocus: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                    onBlur: _cache[3] || (_cache[3] =
                        //@ts-ignore
                        (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                    disabled: _unref(fieldOptions).disabled ?? undefined,
                    required: _unref(fieldOptions).required ?? undefined,
                    multiple: _unref(fieldOptions).multiple ?? undefined,
                    autocomplete: autocomplete.value,
                    id: __props.fieldId,
                    class: "form__control"
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choices.value, (choice) => {
                        return (_openBlock(), _createElementBlock("option", {
                            value: choice.value,
                            key: choice.value,
                            disabled: choice.disabled
                        }, _toDisplayString(choice.label), 9, _hoisted_2));
                    }), 128))
                ], 40, _hoisted_1), [
                    [_vModelSelect, _unref(model)]
                ])
            ]));
        };
    }
});
